import { showErrorDialog } from "..";

export function handleErrorMessage(error: unknown) {
    let errorMessage = "Failed to do something exceptional";
    if (error instanceof Error) {
        errorMessage = error.message;
    }

    showErrorDialog(errorMessage);
}